module.exports = __webpack_public_path__ + "img/FotoMo12.86191952.png";